import React from 'react'

const Assuarance = () => {
  return (
    <section className='lg:w-3/4 lg:mx-[11%] mt-20 lg:mt-[250px] flex flex-col'>
      <div className='w-full md:w-3/4'>
         <h1 className='text-3xl font-bold text-white'>We want to remove the stigma surrounding AI 
         by giving you control.</h1>
         <p className='md:text-xl mt-8 text-white indent-4'>
         Let’s face it. AI is scary. Especially for the older generation, the concept of artificial intelligence 
         is something that can difficult to conceptualize. Are we being spied on? 
         Are they stealing our information? Will AI take over our jobs? At OpenPolitica, 
         we believe that AI doesn’t have to be hard. That’s why we provide options for you 
         to take control of your data and provide a narrative that makes AI much easier to understand.
         </p>
      </div>
    </section>
  )
}

export default Assuarance